<template>
	<div>
		<el-dialog
			title=""
			:visible.sync="loginDialogVisible"
			:close-on-click-modal="false"
			custom-class="login-dialog"
			width="420px">
			<h1>微信扫码登录</h1>
			<p class="second-title">未注册的微信号会自动注册网站账号</p>
			<div class="img-box">
				<img class="code" :src="loginData.code" alt="">
				<img class="wechat-tips" src="@/assets/images/wechat_tips.png" alt="">
			</div>
			<el-divider></el-divider>
			<p class="tips">注册登录即代表同意
				<router-link to="/document" target="_blank">
					<el-link type="danger">用户协议</el-link>
				</router-link>
				和
				<router-link to="/document" target="_blank">
					<el-link type="danger">隐私协议</el-link>
				</router-link>
			</p>
		</el-dialog>
	</div>
</template>

<script setup>
import {ref, onBeforeUnmount} from 'vue'
import {login, loginOut, getUserInfo} from '@/api/member'
import {useMemberStore, useGlobalStore} from '@/pinia'
import {Message, MessageBox} from 'element-ui';
import bus from '@/plugins/bus'
import {v4 as uuidv4} from 'uuid';
import router from "@/router";

const loginDialogVisible = ref(false)
const loginStatusInterval = ref(null)
const loginData = ref({
	"token": "",
	"code": "",
	"live": 0
})

const memberStore = useMemberStore()
const globalStore = useGlobalStore()


//登录
const doLogin = async (callback) => {
	clearInterval(loginStatusInterval.value)
	let res = await login();
	if (res.code === 0) {
		loginDialogVisible.value = true;
		loginData.value = res.data;
		memberStore.token = res.data.token;
		loginStatusInterval.value = setInterval(function () {
			if (loginDialogVisible.value) {
				if (loginData.value.live > 0) {
					loginData.value.live--;
					loginStatus(function () {
						Message.success('登录成功！');
						mergeSite();
						if (typeof callback === 'function') {
							callback()
						}
					});
				} else {
					Message.error('登录超时！');
					loginDialogVisible.value = false
				}
			} else {
				clearInterval(loginStatusInterval.value)
			}
		}, 1000)
	}
}

const mergeSite = async () => {
	if (globalStore.mergeSite.show) {
		MessageBox.confirm(
			'原站点已和当前站点合并，前往合并数据?',
			'提示',
			{
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}
		).then(() => {
			router.push({name: "merge"}, onComplete => {
			}, onabort => {
			})
		}).catch(() => {

		})
	}
}

const doLoginOut = async () => {
	await loginOut();
	memberStore.token = ""
	memberStore.loginStatus = false;
	Message.success("退出成功")
	bus.emit("goHome")
}

//登录状态
const loginStatus = async (callback) => {
	let res = await getUserInfo([], false);
	if (res.code === 0) {
		loginDialogVisible.value = false
		memberStore.member = res.data
		memberStore.loginStatus = true

		if (typeof callback === 'function') {
			callback()
		}
	}
}

const initUuid = async () => {
	if (!memberStore.uuid) {
		memberStore.uuid = uuidv4()
	}
}


bus.on('login', doLogin);
bus.on('loginOut', doLoginOut);
bus.on('memberInfo', loginStatus);
bus.on('uuid', initUuid);
// 在组件卸载之前移除监听
onBeforeUnmount(() => {
	bus.off('login', doLogin);
	bus.off('loginOut', doLoginOut);
	bus.off('memberInfo', loginStatus);
	bus.off('uuid', initUuid);
})
</script>

<style lang="scss" scoped>
:deep(.login-dialog) {
	background: #f7f7f7;
	padding: 0 20px;
	text-align: center;

	h1 {
		color: #000;
	}

	.second-title {
		color: #9a9b9c;
		font-size: 12px;
		font-weight: bold;
	}

	.img-box {
		width: 230px;
		margin: auto;
		border-radius: 5px;
		padding: 10px 0;
		background: #fff;

		.code {
			width: 200px;
			height: 200px;
		}

		.wechat-tips {
			width: 100%;
		}
	}

	.tips {
		a {
			font-size: 12px;
			font-weight: bold;
		}

		color: #9a9b9c;
		font-size: 12px;
		margin-bottom: 0;
		font-weight: bold;
	}
}
</style>